<template>
  <div class="dev-feed-post">
    <div class="pp-model-item pp-model-item-news pp-model-item-post">
      <div class="pp-model-item-content pp-length-flex">
        <div
          class="pp-model-picture pp-length-picture"
          :style="{ backgroundImage: thumb }"
        >
          <div
            v-if="imagesCount + videosCount"
            class="pp-model-picture-extra js-gallery"
          >
            <a
              v-if="imagesCount"
              :href="newsfeedPostImages[0].base64"
              :data-exthumbimage="newsfeedPostImages[0].base64"
              class="pp-model-picture-main"
            ></a>
            <a
              v-for="(image, index) in extraImages"
              v-show="index === 0"
              :key="index"
              :href="image.base64"
              :data-exthumbimage="image.base64"
              class="pp-model-picture-more"
            >
              +{{ imagesCount - 1 }}
            </a>
            <a
              v-for="(video, index) in newsfeedPost.links"
              v-show="index === 0"
              :key="video"
              :href="video"
              class="pp-model-picture-video"
            >
              <i class="fas fa-play-circle"></i>
            </a>
          </div>
        </div>
        <div class="pp-model-info pp-length-info">
          <div class="pp-model-info-strip pp-model-info-strip-header">
            <div class="image" :style="projectImage"></div>
            <h5 class="heading">{{ projectName }}</h5>
          </div>
          <div class="pp-model-info-strip">
            <div class="pp-model-info-text wysiwyg" v-html="newsfeedPost.news">
            </div>
          </div>

          <div class="pp-model-info-strip pp-model-info-strip-date">
            <p class="small" style="font-weight: normal">
              {{ dateHumanize(newsfeedPost.updated_at) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <button
      @click="openEditNewsfeedPostModal(newsfeedPost, newsfeedPostImages)"
      title="Editeaza postarea"
      class="dev-feed-post-action dev-feed-post-edit"
    >
      <i class="fa fa-edit"></i>
    </button>
    <button
      @click="deletePost"
      title="Sterge postarea"
      class="dev-feed-post-action dev-feed-post-delete"
    >
      <i class="fa fa-trash"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "NewsfeedPost",
  props: ["newsfeedPost", "newsfeedPostImages", "newsfeedPostProjectImage"],
  data() {
    return {
      projectName: this.newsfeedPost.project_name,
      postId: this.newsfeedPost.id,
      imagesCount: this.newsfeedPostImages.length,
      videosCount: this.newsfeedPost.links.length,
      extraImages: this.newsfeedPostImages.slice(1),
    };
  },
  computed: {
    projectImage() {
      return {
        'background-image': `url(${this.newsfeedPostProjectImage})`
      }
    },
    thumb() {
      return this.imagesCount
        ? "url(" + this.newsfeedPostImages[0].base64 + ")"
        : "";
    },
  },
  mounted() {},
  methods: {
    deletePost() {
      let vm = this;

      window.Swal.fire({
        title: "Esti sigur?",
        text: "Aceste date nu vor mai putea fi recuperate!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Da, sterge!",
        cancelButtonText: "Nu, anuleaza",
      }).then(function (result) {
        if (result.value) {
          window.axios
            .delete(`/developer/project/delete-news/${vm.postId}`)
            .then(function () {
              window.Swal.fire({
                html: "Postarea a fost stearsa cu succes",
                icon: "success",
                timer: 2000,
                showCancelButton: false,
                showConfirmButton: false,
              }).then(function () {
                const pathname = window.location.pathname;
                window.location.href = `${pathname}?tab=details`;
              });
            })
            .catch(function (err) {
              window.showError(err);
            });
        }
      });
    },
  },
};
</script>
